module.exports = __webpack_public_path__ + "static/media/sad.32678ff9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sad.svg
// module id = 487
// module chunks = 0